/**
 * Storefront sign in — **Google only**.
 *
 * Used by the shop header, Checkout, My Orders and Profile. There is no
 * username/password form on purpose: a form is what bots hammer (fake accounts,
 * brute force, traffic). “Continue with Google” signs the shop customer in and
 * the API creates the customer account on the first visit, from the verified
 * Google email — see `Backend_API/routers/social_auth.py`.
 */
import React from 'react';
import { useShop } from '../contexts/ShopContext';
import { useLanguage } from '../i18n';
import GoogleLogin from './GoogleLogin';

export default function CustomerAuth() {
  const { shop } = useShop();
  const { t } = useLanguage();

  return (
    <div className="space-y-3">
      <p className="text-sm text-center text-gray-500 dark:text-gray-400">{t('googleOnlyLogin')}</p>
      <GoogleLogin scope="customer" shopId={shop?.id} />
    </div>
  );
}
